<div class="edit-project-linked-files-component">
    <div class="attach-file-action">
        <h4 class="job-detail-title">
            {{ 'Survey.SurveyJobPanel.JobDetails.Attachments.LinkedProjectData' | translate }}
        </h4>
        <gsp-button
            [type]="ButtonType.Default"
            text="{{ 'Survey.SurveyEditPanel.LinkFiles' | translate }}"
            (action)="toggleAttachFilesPanelView()"
        ></gsp-button>
    </div>

    <div class="attached-linked-files">
        <job-file-tag-chips
            [files]="chipData"
            [chipType]="JobAttachmentChipType.EditLinkedProjectData"
            [noFilesMessage]="'Survey.SurveyJobPanel.JobDetails.Attachments.NoLinkedProjectData'"
            cancelAction="true"
            (chipAction)="removeLinkedFile($event)"
        ></job-file-tag-chips>
    </div>
</div>
